module.exports = __webpack_public_path__ + "img/ShirleyLiuPhD.9e876a67.png";